// extracted by mini-css-extract-plugin
module.exports = {"content":"IntroTab_content_33_Mq","headline":"IntroTab_headline_2-n_g"};